import { Flex, Box, Text, Message } from 'ui'
import { Footer } from '../Footer'
import { useForm } from 'react-hook-form'
import { CategoryForm, categorySchema } from '../schemas'
import { zodResolver } from '@hookform/resolvers/zod'
import { usePositionEditor } from '../usePositionEditor'
import { PositionTemplatePicker } from 'components/PositionTemplatePicker'
import { usePositionTemplate } from './usePositionTemplate'

export function Category() {
  const { positionData, setPositionData, goNext } = usePositionEditor()
  const {
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
  } = useForm<CategoryForm>({
    resolver: zodResolver(categorySchema),
    defaultValues: positionData.category,
  })
  const positionTemplateId = watch('positionTemplateId')
  const selectedPositionTemplate = usePositionTemplate(positionTemplateId)

  const onSubmit = handleSubmit((data) => {
    // if position template changes, lets reset requirement data subsequently saved
    if (data.positionTemplateId !== positionData.category?.positionTemplateId) {
      setPositionData({
        category: data,
        requirement: undefined,
      })
    } else {
      setPositionData({
        category: data,
      })
    }
    goNext()
  })

  return (
    <form onSubmit={onSubmit}>
      <Flex width={[1, '60rem']} height={'80vh'} flexDirection={'column'}>
        <Box flex={1} overflow={'auto'}>
          <PositionTemplatePicker
            positionTemplateId={positionTemplateId}
            onSelect={(positionTemplateId) => {
              setValue('positionTemplateId', positionTemplateId)
              onSubmit()
            }}
          />
        </Box>
        <Footer
          ctaText={'Next: Job Requirements'}
          leftContent={
            <>
              {selectedPositionTemplate ? (
                <Text mr={3}>
                  Position: <strong>{selectedPositionTemplate.name}</strong>
                </Text>
              ) : errors.positionTemplateId ? (
                <Message variant={'error'}>
                  {errors.positionTemplateId?.message}
                </Message>
              ) : null}
            </>
          }
        />
      </Flex>
    </form>
  )
}
